import React from 'react';
import { Scrollbar } from 'codeArt/components/Base';
import { createIcon, Util } from 'codeArt/common';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Select from './Select';
import { DateTime } from './DateTime';

const space = "c-my-3";

export default class ModuleSide extends React.Component {

  constructor(props) {
    super(props);
  }

  renderSections(sections,itemClassName) {
    let { complex,value } = this.props;
    value = value ||{};
    return sections.map((section, i) => {
      let { type, field } = section;
      let v = value[field]||{};
      switch (type) {
        case "dropdown": {
          return <Dropdown key={field} className={itemClassName} {...section} value={v} section={section} onChange={(o) => this.handleSectionChange(o)} complex={complex} />;
        }
        case "datetime": {
          return <_DateTime key={field} className={itemClassName} {...section} value={v} section={section} onChange={(o) => this.handleSectionChange(o)} />;
        }
        case "empty": {
          return <p />;
        }
        default:
          return <Tiled key={field} {...section} value={v} section={section} onChange={(o) => this.handleSectionChange(o)} complex={complex} />;
      }
    });
  }

  handleSectionChange(item) {  //item:新选择的项
    let { value,onChange } = this.props;
    value = { ...value, ...item };
    if (onChange) onChange(value);
  }

  
  verticalBody(vertical) {
    let {verticalItemPadding} = this.props;
    return <div key={"items"} className="module-nav d-flex flex-column c-my-2 c-flex-1">
      {this.renderSections(vertical,verticalItemPadding?`px-${verticalItemPadding}`:"")}
    </div>;
  }

  tryScrollbar(content) {
    let { vertical } = this.props;
    if (vertical && vertical.filter((t) => t.flex).length > 0) { //如果内部成员有flex:1，即要求某个区域全铺的，那么主区域不要有滚动条
      return content;
    }
    return <Scrollbar>{content}</Scrollbar>;
  }

  vertical() {
    let { width,verticalClassName,full } = this.props;
    let { vertical } = this.props;
    if (!vertical || vertical.length===0) return null;
    if(full){
      return (
        <div className={`d-flex c-m-0 h-100 bg-white c-l ${verticalClassName}`} style={{ width: width }}>
          <div className="d-flex flex-column c-flex-1">
            {this.tryScrollbar(this.verticalBody(vertical))}
          </div>
        </div>)
    }
    return (
      <div className={`d-flex c-m-0 bg-white c-l ${verticalClassName}`} style={{ width: width }}>
        <div className="d-flex flex-column c-flex-1">
          {this.verticalBody(vertical)}
        </div>
      </div>)
  };

  horizontal(){
    let { horizontal,horizontalClassName } = this.props;
    if (!horizontal || horizontal.length===0) return null;
    return (
      <div className={`d-flex flex-row w-100 bg-white c-l px-2 pt-2 ${horizontalClassName}`}>
         {this.renderSections(horizontal,`px-1`)}
      </div>
    );
  }

  renderFull(){
    //全屏模式
    let { className, children } = this.props;
    return (
      <div className={`d-flex flex-row h-100 w-100 ${className}`}>
        {this.vertical()}
        <div className="d-flex flex-column c-flex-1 pl-2">
          {this.horizontal()}
          <div className="d-flex flex-column c-flex-1">
            {children}
          </div>
        </div>
      </div>
    )
  }

  render() {
    let { className, children,full,vertical,horizontal } = this.props;
    if(full) return this.renderFull();
    if(vertical) return this.vertical();
    return this.horizontal();
  }
}

ModuleSide.defaultProps = {
  className:'',
  complex: true,
  full:true,
  verticalClassName:'',
  verticalItemPadding:3,
  horizontalClassName:''
}

class _DateTime extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { section, emptyable, disabled, disabledTip,value,className,width,maxWidth,minWidth,size } = this.props;
    return <DateTime ref={(r) => { this.time = r; }} mode="dateTime" depend={{value:value.value}} width={width} maxWidth={maxWidth} minWidth={minWidth} disabled={disabled} disabledTip={disabledTip} className={`${space} ${className}`} size={size} label={section.label} type="text" emptyable={emptyable} onChange={(v) => { this.handleChange(v); }} />
  }

  handleChange(v) {
    let { section, onChange } = this.props;
    let o = {};
    o[section.field] = {value:v};
    if (onChange) onChange(o);
  }
}

class Dropdown extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { section, emptyable, disabled, multiple, disabledTip, value,className,width,maxWidth,minWidth,size } = this.props;
    let items = section.items;

    if (items && items.length > 0) {
      return <Select call={section.label} size={size} multiple={multiple} width={width} maxWidth={maxWidth} minWidth={minWidth} label={section.label} emptyable={emptyable}
        depend={{value:value.value}}
        className={`${space} ${className}`} options={items} 
        onChange={(v) => { this.handleChange(v) }} 
        />
    } else {
      return <Select call={section.label} size={size} multiple={multiple} width={width} maxWidth={maxWidth} minWidth={minWidth} label={section.label} emptyable={emptyable} disabled={disabled} disabledTip={disabledTip}
        depend={{value:value.value}}
        className={`${space} ${className}`} options={items} 
        onChange={(v) => { this.handleChange(v) }} 
        />
    }
  }

  handleChange(v) {

    let { section,onChange } = this.props;
    let items = section.items||[];

    let data = {};

    if(section.multiple){
      //todo
      alert("目前不支持多选，可以补充");
    }else{
      let target = Util.first(items, (t) => t.value == v);
      data[section.field] = target;
    }

    if (onChange) onChange(data);
  }
}

Dropdown.defaultProps = {
  emptyable: false,
  disabled: false,
  disabledTip: "请选择机组"
}

class Tiled extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { section } = this.props;
    return (
      [this.renderHeaer(),
      <div key={`menu-section-${section.field}-body`} className="d-flex flex-column c-flex-1">
        <Scrollbar autoHide={false}>
          <ul className="c-p-0">
            {this.renderBody()}
          </ul>
        </Scrollbar>
      </div>]
    );
  }

  renderHeaer() {
    let { section } = this.props;
    if (!section.label) return;
    return (<div key={`menu-section-${section.field}`} className="module-nav-label c-py-1d5 c-px-0 c-text-s1d5 m-text-dark75">
      {section.label}
    </div>);
  }

  renderBody() {
    let { section } = this.props;
    let { items, field } = section;

    return items.map((item, i) => {
      let { icon, text, label } = item;
      let selected = this.isSelected(item);
      return <li key={`menu-${field}-${i}`} onClick={() => { this.handleClick(item,selected); }}>
        <span className={`jr-link d-flex flex-row justify-content-start align-items-center c-py-2 c-px-0 ${selected ? 'active' : ''}`}>
          {createIcon(icon || ArrowRightIcon, "c-icon-s1d5")}
          <p className={`c-flex-1 c-text-s1d5 ${icon ? "pl-2" : ''} c-ellipsis-1 c-mb-0`}>{text || label}</p>
        </span>
      </li>
    });
  }

  isSelected(item) {
    let {value,multiple} = this.props;
    if(multiple){
      return value && value.find && value.find((t) => t.value == item.value);
    }
    return value.value==item.value;
  }

  handleClick(item,selected) { //selectd：item是否已经被选择了
    let { section,value,multiple,onChange } = this.props;
    let data = {};
    if(multiple){
      value = [...value]; //克隆一下，避免直接对属性赋值
      if(selected){
        Util.remove(value, (t) => t.value == item.value);
      }else{
        value.push(item);
      }
      data[section.field] = value;
    }else{
      //目前单选是没有取消选择的
      data[section.field] = item;
    }

    if (onChange) onChange(data);
  }
}